import * as types from '@/store/types'
export default {
    variablesAll: (context, payload) => {
        context.variables = payload
        context.variablesLoaded = true
    },
    variablesListsAll: (context, payload) => {
        let unsortedVariablesListId = payload.find(variablesList => variablesList.deleted === 2)
        context.unsortedVariablesListId = unsortedVariablesListId.id
        context.variablesLists = payload
        context.variablesListsLoaded = true
    },
    loadScenarios(context, payload) {
        context.scenarios = payload
    },
    setScenario: (context, payload) => {
        const index = context.scenarios.findIndex(item => item.id === payload.id)
        context.scenarios[index] = payload
    },
    changeBotIdModelDefault: (context, botId) => {
        context.variableDefault.bot_id = botId
        context.variablesListDefault.bot_id = botId
    },
    setVariable: (context, payload) => {
        const index = context.variables.findIndex(item => item.id === payload.id)
        context.variables[index] = payload
    },
    addVariable(context, payload) {
        context.variables.push(payload)
    },
    allLoadedChangeValue(context, value) {
        context.variablesLoaded = value
        context.variableListsLoaded = value
    },
    setVariablesList(context, payload) {
        const index = context.variablesLists.findIndex(item => item.id === payload.id)
        context.variablesLists[index] = payload
    },
    addVariablesList(context, payload) {
        context.variablesLists.push(payload)
    },
    deleteVariablesList(context, payload) {
        const index = context.variablesLists.findIndex(item => item.id === payload.id)
        context.variablesLists.splice(index, 1)
    },
    variablesClientAll(context, payload) {
        context.variablesClient.push(payload)
    },
    variablesClientUpdate(context, payload) {
        let indexClient = context.variablesClient.findIndex(variableClient => +variableClient.user_id === payload.user_id)
        let indexVariableClient = context.variablesClient[indexClient].variablesClient.findIndex(variableClient => +variableClient.variable_id === payload.variable_id)
        context.variablesClient[indexClient].variablesClient[indexVariableClient].value = payload.value
        context.variablesClient[indexClient].variablesClient[indexVariableClient].updated_at = payload.updated_at
    }
}
